import { render, staticRenderFns } from "./OrderSearchItem.vue?vue&type=template&id=99ff8058&"
import script from "./OrderSearchItem.vue?vue&type=script&lang=ts&"
export * from "./OrderSearchItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports